import { Button } from "@endya-conformite/ui-kit";
import XLg from "@endya-conformite/ui-kit/src/assets/icons/x-lg.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import styles from "./ConformiteSocieteActions.module.scss";

type ConformiteSocieteActionsProps = {
  isLoading: boolean;
  stopEditing: () => void;
  onClick: () => void;
};
export function ConformiteSocieteActions({
  isLoading,
  stopEditing,
  onClick,
}: ConformiteSocieteActionsProps) {
  return (
    <div className={styles.actions}>
      <Button variant="text" icon={<XLg />} onClick={stopEditing}>
        Annuler les modifications
      </Button>
      <Button
        onClick={onClick}
        type="submit"
        icon={isLoading ? <Loader /> : undefined}
      >
        Enregistrer
      </Button>
    </div>
  );
}
